var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fosun-tabs",class:{ 'circle-tabs': _vm.circle }},[_c('van-tabs',_vm._g(_vm._b({attrs:{"lazy-render":false},model:{value:(_vm.v),callback:function ($$v) {_vm.v=$$v},expression:"v"}},'van-tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }